var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveTickMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9997 8.76595L18.3164 7.9991L10.5313 15.5366L6.68195 11.8092L5.9997 12.5771L10.5675 16.9991L11.0156 16.4973L18.9997 8.76595ZM11.999 0.96C5.912 0.96 0.96 5.912 0.96 11.999C0.96 18.086 5.912 23.039 11.999 23.039C18.086 23.039 23.039 18.086 23.039 11.999C23.039 5.912 18.086 0.96 11.999 0.96ZM11.999 23.999C5.383 23.999 0 18.616 0 11.999C0 5.383 5.383 0 11.999 0C18.616 0 23.999 5.383 23.999 11.999C23.999 18.616 18.616 23.999 11.999 23.999Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveTickMark);
export default __webpack_public_path__ + "static/media/active-tick-mark.499ac684774896937cf6165a0c494bad.svg";
export { ForwardRef as ReactComponent };